import { render, staticRenderFns } from "./Placemat.vue?vue&type=template&id=3abcb68a&scoped=true"
import script from "./Placemat.vue?vue&type=script&lang=js"
export * from "./Placemat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abcb68a",
  null
  
)

export default component.exports